import {firstValueFrom} from 'rxjs';
import {LangService} from './lang.service';

export function TranslateInit(langService: LangService) {
    return () => firstValueFrom(langService.preload()).catch(() => undefined);
}
